import { createUseStyles } from 'react-jss';

import { AbsoluteWhiteColors } from '@picsart/design-system/foundation/colors';
import { Easings } from '@picsart/design-system/foundation/easings';
import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { FontSizes } from '@picsart/design-system/foundation/typography';

const useStyles = createUseStyles(
  {
    hint: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: Spacings.s4,
      color: AbsoluteWhiteColors.base.default,
      pointerEvents: 'none',
      animation: `$fadeIn 0.6s ${Easings.easeOut} 1.5s backwards`,
    },
    chevron: {
      display: 'block',
      width: Spacings.s40,
      height: Spacings.s40,
      animation: `$bounce 1.4s ${Easings.easeInOut} infinite`,
    },
    label: {
      fontSize: FontSizes.t6,
      fontWeight: FontWeights.medium,
    },
    '@keyframes fadeIn': {
      from: { opacity: 0 },
      to: { opacity: 1 },
    },
    '@keyframes bounce': {
      '0%, 100%': { transform: 'translateY(0)' },
      '50%': { transform: `translateY(calc(-1 * ${Spacings.s8}))` },
    },
    '@media (prefers-reduced-motion: reduce)': {
      hint: { animation: 'none' },
      chevron: { animation: 'none' },
    },
  },
  { name: 'feed-scroll-hint' }
);

export default useStyles;
